var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3501 19.4719C6.82485 19.4719 7.21073 19.8435 7.21073 20.3007C7.21073 20.7578 6.82485 21.1283 6.3501 21.1283C5.87535 21.1283 5.4906 20.7578 5.4906 20.3007C5.4906 19.8435 5.87535 19.4719 6.3501 19.4719Z",
    stroke: "#464646",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.009 19.4719C19.4838 19.4719 19.8696 19.8435 19.8696 20.3007C19.8696 20.7578 19.4838 21.1283 19.009 21.1283C18.5343 21.1283 18.1484 20.7578 18.1484 20.3007C18.1484 19.8435 18.5343 19.4719 19.009 19.4719Z",
    stroke: "#464646",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09363 1.52075L3.43363 1.91075L4.517 14.3398C4.60475 15.3528 5.48338 16.1306 6.53863 16.1306H18.8146C19.8226 16.1306 20.6776 15.4178 20.8228 14.4558L21.8904 7.35125C22.022 6.47484 21.3166 5.6905 20.3975 5.6905H3.80938",
    stroke: "#464646",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8911 9.69458H17.0107",
    stroke: "#464646",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d30f391c60f9166ca8d0cf9a3bb251e9.svg";
export { ForwardRef as ReactComponent };